/** @jsxImportSource react */
import clsxm from '@common/lib/clsxm';
import { forwardRef } from 'react';

type SectionProps = {
  heading?: string;
  subHeader?: string;
  children?: React.ReactNode;
  className?: string;
} & React.ComponentPropsWithRef<'section'>;

const DatahubSection = forwardRef<HTMLDivElement, SectionProps>(
  ({ heading, subHeader, children, className, ...props }, ref) => {
    return (
      <>
        <section
          className={clsxm('font-b-m mb-6 space-y-4 px-4 lg:px-0', className)}
          ref={ref}
          {...props}
        >
          {heading && <h2 className='font-t-l'>{heading}</h2>}
          {subHeader && <div className='font-medium'>{subHeader}</div>}
          {children}
        </section>
      </>
    );
  }
);

export default DatahubSection;
